import React, { useContext, useEffect } from "react";
import axios from "./axios";
import { withRouter } from "react-router-dom";

import { AlertContext } from "./context/states/alertState";
import { AuthContext } from "./context/states/authState";

import withErrorHandler from "./middlewares/withErrorHandler";

import Layout from "./layouts/Layout";
import Routes from "./Routes";

import { Snackbar, IconButton } from "@material-ui/core";

import Slide from "@material-ui/core/Slide";
import CloseIcon from "@material-ui/icons/Close";

function App() {
  const { open, message, alertSnackbarCloseHandle } = useContext(AlertContext);

  const { token } = useContext(AuthContext);

  // set auth header
  useEffect(() => {
    const storedToken = localStorage.getItem("token");

    if (storedToken) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${storedToken}`;
    } else {
      delete axios.defaults.headers.common["Authorization"];
    }
  }, [token]);

  function SlideTransition(props) {
    return <Slide {...props} direction="up" />;
  }

  return (
    <React.Fragment>
      <Layout>
        <Routes />
      </Layout>

      {open && (
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          open={open}
          message={message}
          autoHideDuration={3000}
          onClose={alertSnackbarCloseHandle}
          TransitionComponent={SlideTransition}
          action={
            <React.Fragment>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={alertSnackbarCloseHandle}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </React.Fragment>
          }
        />
      )}
    </React.Fragment>
  );
}

export default withErrorHandler(withRouter(App), axios);
